// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"b3ca9813","497":"c1290d2d"}[chunkId] + ".chunk.css";
};